import { render, staticRenderFns } from "./OrdersOpenedBadge.vue?vue&type=template&id=945fb3c8&"
import script from "./OrdersOpenedBadge.vue?vue&type=script&lang=js&"
export * from "./OrdersOpenedBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
